/*
 * @Author: alex
 * @Date: 2022-05-07 13:53:50
 * @LastEditTime: 2022-07-07 15:20:30
 * @LastEditors: maqingyi
 */
import { WebPlugin } from '@capacitor/core';
export class SqlitePluginWeb extends WebPlugin {
    async updateEntity(options) {
        console.log(options);
        return { data: 'not supported' };
    }
    async delEntity(options) {
        console.log(options);
        return { data: 'not supported' };
    }
    async insertEntity(options) {
        console.log(options);
        return { data: 'not supported' };
    }
    async queryForList(options) {
        console.log(options);
        return { data: [{ data: 'not supported' }] };
    }
    async queryForObject(options) {
        console.log(options);
        return { data: { data: 'not supported' } };
    }
    async loadDatabase(options) {
        console.log(options);
        return { data: 'not supported' };
    }
    /**
     * 测试方法
     * @param options 参数
     * @returns 相同值
     */
    async echo(options) {
        console.log('ECHO', options);
        return options;
    }
}
//# sourceMappingURL=web.js.map